var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("疗养预约系统")]),
              _c("el-breadcrumb-item", [_vm._v("公告信息")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "hx-form-container box-shadow" },
        [
          _c(
            "el-form",
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.add },
                            },
                            [_vm._v(" 发布公告 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: { "page-info": _vm.pager, loading: _vm.tableLoading },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c("hx-table-result-col", [
            _c(
              "div",
              {
                staticClass: "wrap-table-info-display",
                staticStyle: { height: "32px" },
              },
              [
                _c("span", { staticClass: "table-info-display" }, [
                  _c("span", [_vm._v("总条数：")]),
                  _c("span", { staticClass: "alert-text ft16" }, [
                    _vm._v(_vm._s(_vm.pager.total)),
                  ]),
                ]),
              ]
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: {
                slot: "content",
                data: _vm.tableData,
                "max-height": "800",
                border: "",
              },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "publishTime",
                  align: "center",
                  label: "发布时间",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "title", align: "center", label: "标题" },
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "confirm-button",
                          {
                            staticStyle: { margin: "0 10px" },
                            attrs: {
                              type: "text",
                              title: "确认要删除该条数据？",
                            },
                            on: {
                              confirmed: function ($event) {
                                return _vm.deleteItem(scope.row.id)
                              },
                            },
                          },
                          [_c("span", [_vm._v("删除")])]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.detailItem(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }